export default __webpack_public_path__ + "static/wunschpiercing-6-b7d2cef6cf813014145e20a82ee7d775.jpg";